import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
  padding-left: 50px;
`

/* Na aba online sobram a busca e o profissional: sem período, status e o seletor de ativos e inativos. */
export const FilterContainer = styled(Container)`
  display: grid;
  grid-template-columns: ${({ $online }) => $online ? '250px 180px' : '250px 220px 180px 200px 180px'};
  align-items: flex-start;
  height: auto;
  padding: 0px;
  margin-bottom: 20px;
  gap: 12px;

  @media (max-width: 1239px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    div {
      max-width: 220px;
    }
  }
`

export const Title = styled.p`
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 15px;
`
